import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Loader2, Mail } from "lucide-react";
import { formatCurrency } from "@/lib/api";

const EMPTY = { open: false, order: null, email: "", message: "", sending: false };

/**
 * Dialogue pour relancer le paiement de l'acompte par email.
 */
export const SendReminderDialog = ({ reminderDialog, setReminderDialog, onSend }) => {
  const { open, order, email, message, sending } = reminderDialog;

  const close = () => setReminderDialog(EMPTY);

  return (
    <Dialog
      open={open}
      onOpenChange={(v) => !v && close()}
    >
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Relancer l'acompte par email</DialogTitle>
          <DialogDescription>
            Un email pré-rempli sera envoyé au client avec la référence, le montant TTC et l'acompte attendu.
          </DialogDescription>
        </DialogHeader>
        {order && (
          <div className="space-y-3">
            <div className="bg-slate-50 p-3 rounded-sm border text-sm space-y-1">
              <div><span className="text-muted-foreground">Commande :</span> <strong>{order.reference}</strong></div>
              <div><span className="text-muted-foreground">Client :</span> <strong>{order.client_name}</strong></div>
              <div><span className="text-muted-foreground">Montant TTC :</span> <strong>{formatCurrency(order.amount_ttc || 0)}</strong></div>
              <div><span className="text-muted-foreground">Acompte attendu :</span> <strong className="text-orange-700">{formatCurrency(order.deposit_amount || (order.amount_ttc || 0) * 0.4)}</strong></div>
            </div>
            <div className="space-y-2">
              <Label>Email du client *</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setReminderDialog(d => ({ ...d, email: e.target.value }))}
                placeholder="client@exemple.fr"
                data-testid="reminder-email"
              />
            </div>
            <div className="space-y-2">
              <Label>Message personnalisé (facultatif)</Label>
              <textarea
                value={message}
                onChange={(e) => setReminderDialog(d => ({ ...d, message: e.target.value }))}
                rows={3}
                className="w-full border rounded-sm p-2 text-sm"
                placeholder="Ex : Comme convenu lors de notre échange du..."
                data-testid="reminder-message"
              />
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={close}>
            Annuler
          </Button>
          <Button onClick={onSend} disabled={sending} data-testid="send-reminder-btn">
            {sending && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
            <Mail className="h-4 w-4 mr-2" /> Envoyer la relance
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SendReminderDialog;
